import { compose } from 'recompose';

import BrillMask from './brillMask';

const enhance = compose();
export default enhance(BrillMask);
